



















import { Vue, Component, Prop } from 'vue-property-decorator';
import CommonDialog from '../../../components/organisms/CommonDialog.vue';
import { D_FORMAT_JA, dayjs } from '../../../../src_server/common/momentExtends';
import { LocalData } from '../../../utils/LocalData';

@Component({
  components: { CommonDialog },
  filters: {
    dateFormat(dt: Date) {
      return dayjs(dt).format(D_FORMAT_JA);
    },
    trim(title: string) {
      if (title.length < 30) {
        return title;
      } else {
        return `${title.substring(1, 30)}...`;
      }
    },
  },
})
export default class NewsAndEventDialog extends Vue {
  private type = '';
  private data: any[] = [];
  get title() {
    return this.type === 'event' ? 'イベント' : 'ニュース';
  }

  isReadYet(id: number) {
    const ids = LocalData.getShownNewsAndEvent();
    return ids.includes(id);
  }

  public async show(type: string, data: any[]) {
    this.type = type;
    this.data = data;
    (this.$refs['event_news_dialog'] as CommonDialog).show();
  }

  public close() {
    (this.$refs['event_news_dialog'] as CommonDialog).hide();
  }

  closed() {
    this.saveShownData(this.data);
  }

  saveShownData(data: any[]) {
    LocalData.setShownNewsAndEvent(data.map((d) => d.notice_id));
  }
}
